import { Card, SimpleGrid, Stack, Text } from '@mantine/core';
import { formatCurrency } from './billingFormatters';

interface AdjudicationSummaryProps {
  billed: number;
  allowed: number;
  paid: number;
  adjustment: number;
  patientResp: number;
}

function SummaryCard({ label, value }: { label: string; value: number }): JSX.Element {
  return (
    <Card withBorder padding="md" radius="md">
      <Stack gap={4}>
        <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
          {label}
        </Text>
        <Text size="lg" fw={700}>
          {formatCurrency(value)}
        </Text>
      </Stack>
    </Card>
  );
}

export function AdjudicationSummary({
  billed,
  allowed,
  paid,
  adjustment,
  patientResp,
}: AdjudicationSummaryProps): JSX.Element {
  return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 5 }} spacing="md">
      <SummaryCard label="Billed" value={billed} />
      <SummaryCard label="Allowed" value={allowed} />
      <SummaryCard label="Payer Paid" value={paid} />
      <SummaryCard label="Adjustments" value={adjustment} />
      <SummaryCard label="Patient Resp." value={patientResp} />
    </SimpleGrid>
  );
}
